
  document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth < 768) {
      const items = document.querySelectorAll('.announcement-bar--grid .grid__item');
      let current = 0;

      function showSlide(index) {
        items.forEach((item, i) => {
          item.classList.toggle('active', i === index);
        });
      }

      if (items.length > 1) {
        showSlide(current);
        setInterval(() => {
          current = (current + 1) % items.length;
          showSlide(current);
        }, 4000); // Skift hvert 4. sekund – tilpas efter behov
      }
    }
  });
